export const ON_SCREEN_RATIO = 0.5;
// Browsers can report a ratio a hair under the threshold they just crossed, e.g. 0.4997 with fractional pixel sizes
const RATIO_TOLERANCE = 0.01;

type Entry = Pick<
  IntersectionObserverEntry,
  'isIntersecting' | 'intersectionRatio' | 'intersectionRect' | 'rootBounds'
>;

/**
 * A post is on screen when at least half of it is visible, or, for a post taller than twice the viewport, when it
 * covers at least half of the viewport.
 */
export function isPostOnScreen(entry: Entry, viewportHeight: number) {
  if (!entry.isIntersecting) return false;
  if (entry.intersectionRatio >= ON_SCREEN_RATIO - RATIO_TOLERANCE) return true;
  const rootHeight = entry.rootBounds?.height ?? viewportHeight;
  return rootHeight > 0 && entry.intersectionRect.height >= rootHeight * ON_SCREEN_RATIO;
}
